export default "__VITE_ASSET__BFWBKX9M__"